'use client'

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string }
  reset: () => void
}) {
  return (
    <div className="flex min-h-screen items-center justify-center bg-white p-6">
      <div className="flex min-h-[200px] w-full max-w-md flex-col items-center justify-center gap-3 rounded-xl border border-red-100 bg-red-50 p-6 text-center">
        <p className="text-base font-semibold text-red-700">
          문제가 발생했습니다.
        </p>
        <p className="text-sm text-red-600">잠시 후 다시 시도해 주세요.</p>
        <p className="max-w-full break-all text-xs text-red-500">
          {error.message}
        </p>
        <button
          type="button"
          onClick={reset}
          className="rounded-md bg-red-600 px-4 py-2 text-sm font-semibold text-white transition-colors hover:bg-red-700"
        >
          다시 시도
        </button>
      </div>
    </div>
  )
}
